import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const getMembershipOverview = async (clientId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_CLIENT_MEMBERSHIP_OVERVIEW}?ClientId=${clientId}`
    );
    return response.data;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const updateWeightGoal = async (payload) => {
  const { coachId, clientId } = payload;
  const reqParams = {
    targetWeight: payload.targetWeight,
    targetDate: payload.targetDate,
    currentWeight: payload.currentWeight,
    maintainCurrentWt: payload.maintainCurrentWeight,
  };

  try {
    const response = await axiosInstance.post(
      `${Endpoints.UPDATE_CLIENT_WEIGHT_GOAL}/${coachId}/${clientId}`,
      reqParams
    );
    return response;
  } catch (error) {
    throw error?.data.message || error?.data?.message || "Something went wrong.";
  }
};
